import classed from "classed-components"

export const GlossOver = classed.div<{ visible: boolean }>([
    "glossover",
    ({ visible }) => ({ block: visible }),
    ({ visible }) => ({ hidden: !visible }),
])
